import React from "react";
import { Props } from "./Props";

const UmbrellaIcon: React.FC<Props> = ({ fill, otherProps }) => {
  const { width, height } = otherProps;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.5 18V1C9 1 3.43182 11.8935 3 18H23.5Z" fill={fill} />
      <path
        d="M18.9189 43.3904C18.9189 44.2631 19.2656 45.1001 19.8827 45.7172C20.4998 46.3343 21.3367 46.6809 22.2094 46.6809C23.0821 46.6809 23.9191 46.3343 24.5362 45.7172C25.1533 45.1001 25.5 44.2631 25.5 43.3904V22M4.78125 25.0378C4.78125 19.5429 6.96411 14.273 10.8496 10.3874C14.7352 6.50192 20.005 4.31906 25.5 4.31906C30.995 4.31906 36.2648 6.50192 40.1504 10.3874C44.0359 14.273 46.2187 19.5429 46.2188 25.0378"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 25C5 23.6739 5.71994 22.4021 7.00144 21.4645C8.28294 20.5268 10.021 20 11.8333 20C13.6456 20 15.3837 20.5268 16.6652 21.4645C17.9467 22.4021 18.6667 23.6739 18.6667 25C18.6667 23.6739 19.3866 22.4021 20.6681 21.4645C21.9496 20.5268 23.6877 20 25.5 20C27.3123 20 29.0504 20.5268 30.3319 21.4645C31.6134 22.4021 32.3333 23.6739 32.3333 25C32.3333 24.3434 32.5101 23.6932 32.8535 23.0866C33.1969 22.48 33.7002 21.9288 34.3348 21.4645C34.9693 21.0002 35.7226 20.6319 36.5517 20.3806C37.3807 20.1293 38.2693 20 39.1667 20C40.064 20 40.9526 20.1293 41.7817 20.3806C42.6107 20.6319 43.364 21.0002 43.9986 21.4645C44.6331 21.9288 45.1364 22.48 45.4798 23.0866C45.8233 23.6932 46 24.3434 46 25"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24 6C22.6316 7.03704 19.5158 11.2889 18 20"
        stroke="black"
        stroke-linecap="round"
      />
      <path
        d="M27 6C28.1404 7.03704 30.7368 11.2889 32 20"
        stroke="black"
        stroke-linecap="round"
      />
      <path d="M25.5 4.01359V1" stroke="black" stroke-linecap="round" />
      <defs>
        <linearGradient
          id="paint0_linear_4_20"
          x1="14"
          y1="2"
          x2="14"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFA543" />
          <stop offset="1" stop-color="#FFCC83" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default UmbrellaIcon;
